// extracted by mini-css-extract-plugin
export default {"headerRow":"ZiPYxoxI8_kr7tH6HPb7"};